export const ASMARA = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const DARA = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const LSBD = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const BBRC = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const OCEAN = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const SAVOY = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const RICHMONDE = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#e42e29',
  colorSecondary: '#64c0b6',
}

export const KINGSFORD = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#04385D',
  colorSecondary: '#BF9A45',
}

export const GRANDWESTSIDE = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#04385D',
  colorSecondary: '#BF9A45',
}

export const TWINLAKES = {
  fontPrimary: 'Poppins',
  fontSecondary: 'serif',
  primaryFontColor: '',
  secondaryFontColor: '',
  isGoogleFontPrimary: false,
  isGoogleFontSecondary: false,
  fontColorPrimary: '#ffff',
  fontColorSecondary: '#000000',
  colorPrimary: '#04385D',
  colorSecondary: '#BF9A45',
}

export const templates = {
  DARA,
  LSBD,
  BBRC,
  SAVOY,
  RICHMONDE,
  KINGSFORD,
  GRANDWESTSIDE,
  TWINLAKES,
  ASMARA,
  OCEAN,
}
